import store from "@/store";
export default {
    methods: {
        can(vm) {
            let user = store.getters["user"];
            let roles = vm.split(';')
            let check
            for (let i = 0; i < roles.length; i++) {
                check = user.roles.find((e) => e.i18n === roles[i])
                break
            }
            return check ? true : false;
        },
    },
};
